import PropTypes from "prop-types";

export const baseSelectPropTypes = {
  id: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.array,
    PropTypes.string,
    PropTypes.number,
  ]),
  name: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  isMulti: PropTypes.bool,
  isClearable: PropTypes.bool,
  isInvalid: PropTypes.bool,
  isSearchable: PropTypes.bool,
  isDisabled: PropTypes.bool,
  addBlank: PropTypes.bool,
  components: PropTypes.shape({}),
  tooltipText: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  tooltipPlacement: PropTypes.string,
  tooltipClassName: PropTypes.string,
};
